import Marquee from "react-fast-marquee";

const WORDS = [
  "Çatı GES", "Arazi GES", "Tarımsal Sulama", "Öz Tüketim",
  "Sessiz Jeneratör", "EV Şarj İstasyonu", "Danışmanlık", "Bakım & O&M",
];

export const EditorialMarquee = () => (
  <section data-testid="editorial-marquee" className="relative border-y border-white/10 bg-black py-8 overflow-hidden">
    <Marquee speed={40} gradient={false} autoFill>
      {WORDS.map((w, i) => (
        <div key={i} className="flex items-center gap-8 px-8">
          <span className="text-4xl sm:text-6xl font-display font-light tracking-tight text-neutral-700">
            {w}
          </span>
          <span className="text-[#5CC528] text-2xl">✦</span>
        </div>
      ))}
    </Marquee>
  </section>
);
